const AsyncStorage = {
  getItem: async (key) => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: async (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch {}
  },
  removeItem: async (key) => {
    try {
      localStorage.removeItem(key);
    } catch {}
  },
  clear: async () => {
    try {
      localStorage.clear();
    } catch {}
  },
  multiGet: async (keys) => {
    return keys.map((key) => [key, localStorage.getItem(key)]);
  },
};

export default AsyncStorage;
